<template>
    <div>
        <!--
            /* SEMAFORO:
                1 - CONCLUIDO
                2 - PENDENTE
                3 - NAO CONCLUIDO
            */
            /*
                CATEGORIAS:
                1 - Disc Concluidas (ordem 1)
                2 - Disc Pendentes (ordem 1)
                3 - Aproveitamento de Estudos (ordem 1)
                4 - Optativas (ordem 3)
                5 - Eletivas (ordem 4)
                6 - Disc Equivalentes (ordem 5)
                7 - --
                8 - Atividades Complementares (ordem 7)
                9 - Disc Extras (ordem 8)
            */
            /*
                ORDEM:
                1 - concluidas, pendentes e aproveitamento
                2 - --
                3 - Optativas
                4 - eletivas
                5 - equivalentes
                6 - --
                7 -
                8 -
             */
         -->
         <modal-gdb ref="modal_caderno_formando" code="modal_caderno_formando"
            toolbar-title="Caderno de Formando" dialogWidth="100%">
            <template v-slot:activate-slot>
                <span></span>
            </template>
            <template v-slot:body>
                <div v-if="selectedAlu && selectedAlu.aluno">
                    <v-row>
                        <v-col cols="12" sm="2" md="2">
                            <b>R.A.: </b> <div>{{selectedAlu.aluno.RA}}</div>
                        </v-col>
                        <v-col cols="12" sm="5" md="4">
                            <b>Nome: </b> <div>{{selectedAlu.aluno.NOME}}</div>
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                            <b>Curso.: </b> <div>{{selectedAlu.aluno.CURSO}}</div>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <b>Matriz: </b> <div>{{selectedAlu.aluno.CODGRADE}}</div>
                        </v-col>
                        <!-- <v-col cols="12" sm="4" md="4">
                            <b>Turma: </b> <div>{{selectedAlu.aluno.CODTURMA}}</div>
                        </v-col> -->
                        <v-col cols="12" sm="2" md="1">
                            <b>Situação: </b> <div>{{selectedAlu.aluno.CODSTATUS}}</div>
                        </v-col>
                        <v-col cols="12" sm="2" md="1">
                            <b>CR: </b> <div>{{selectedAlu.detalhes.length > 0 ? selectedAlu.detalhes[0].CR : ''}}</div>
                        </v-col>
                        <v-col cols="12" sm="8" md="10" >
                            <b>Legenda:</b>
                            <v-card-text class="px-2 py-1">
                                <span class="ml-6"> <v-icon small :color="semaforo_color(1)">mdi-circle</v-icon> Concluída</span>
                                <span class="ml-6"> <v-icon small :color="semaforo_color(2)">mdi-circle</v-icon> Pendente</span>
                                <span class="ml-6"> <v-icon small :color="semaforo_color(3)">mdi-circle</v-icon> Não concluída</span>
                            </v-card-text>
                        </v-col>
                    </v-row>
                    <v-card>
                        <v-row v-if="selectedAlu.detalhes.length > 0">
                            <v-col cols="12" sm="3">
                                <v-card>
                                    <v-card-text>
                                        Disc. Obrigatórias
                                        <v-divider class="my-2"></v-divider>
                                        <v-row>Total: <v-spacer></v-spacer>{{selectedAlu.detalhes[0].DISC_OBRIG}}</v-row>
                                        <v-row>Concluídas: <v-spacer></v-spacer>{{selectedAlu.detalhes[0].DISC_CONC}}</v-row>
                                        <v-row>Pendentes: <v-spacer></v-spacer>{{selectedAlu.detalhes[0].DISC_PEND}}</v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-card>
                                    <v-card-text>
                                        Disc. Optativas
                                        <v-divider class="my-2"></v-divider>
                                        <v-row>CH Total: <v-spacer></v-spacer>{{selectedAlu.detalhes[0].OPT_CH_TOTAL}}</v-row>
                                        <v-row>Concluídas: <v-spacer></v-spacer>{{selectedAlu.detalhes[0].OPT_CH_CONC}}</v-row>
                                        <v-row>Pendentes: <v-spacer></v-spacer>{{selectedAlu.detalhes[0].OPT_CH_PEND}}</v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-card>
                                    <v-card-text>
                                        Disc. Eletivas
                                        <v-divider class="my-2"></v-divider>
                                        <v-row>CH Total: <v-spacer></v-spacer>{{selectedAlu.detalhes[0].ELET_CH_TOTAL}}</v-row>
                                        <v-row>Concluídas: <v-spacer></v-spacer>{{selectedAlu.detalhes[0].ELET_CH_CONC}}</v-row>
                                        <v-row>Pendentes: <v-spacer></v-spacer>{{selectedAlu.detalhes[0].ELET_CH_PEND}}</v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-card>
                                    <v-card-text>
                                        Ativ. Complementar
                                        <v-divider class="my-2"></v-divider>
                                        <v-row>CH total: <v-spacer></v-spacer>{{selectedAlu.detalhes[0].COMP_CURR_REQ}}</v-row>
                                        <v-row>Concluídas: <v-spacer></v-spacer>{{selectedAlu.detalhes[0].COMP_CURR_CONC}}</v-row>
                                        <v-row>Pendentes: <v-spacer></v-spacer>{{selectedAlu.detalhes[0].COMP_CURR_PEND}}</v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12">
                                <v-card>
                                    <v-card-text class="py-1">
                                        <b>CH Curso: </b>
                                        {{selectedAlu.detalhes[0].TOTAL_CH_INTEGRALIZADA}} / {{selectedAlu.detalhes[0].TOTAL_CH}}
                                        <!-- <v-divider class="my-2"></v-divider>
                                        <v-row>CH Curso: <v-spacer></v-spacer>
                                        </v-row>
                                        <v-row>CH Integr: <v-spacer></v-spacer>
                                        </v-row> -->
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-card class="my-2">
                        <v-card-text class="pa-1">
                            <div class="analise-curricular" style="overflow-y: auto;padding: 20px;height: 40vh;">
                                <v-divider class="my-2"></v-divider>
                                <h3 class="my-2">Matriz Curricular</h3>
                                <v-divider class="my-2"></v-divider>
                                <div class="disciplinas-normais" v-for="periodo, pi in Array.from(new Set(selectedAlu.curriculo.filter( d => d.CODPERIODO).map(p => p.CODPERIODO)))" :key="'0_'+pi">
                                    <h4>{{periodo}}º PERIODO</h4>
                                    <v-row
                                        v-for="disc, di in selectedAlu.curriculo.filter( d => d.ORDEM == 1 && d.CODPERIODO === periodo)"
                                        :key="'1_'+di" class="ml-3">
                                        <span v-if="disc.CATEGORIAID !== 3">
                                            <v-icon small :color="semaforo_color(disc.SEMAFORO)">mdi-circle</v-icon>
                                            {{disc.CODDISC}} -
                                        </span>
                                        <span v-else>*</span>
                                        {{disc.DISCIPLINA}}
                                        <v-spacer></v-spacer>
                                        {{disc.STATUS}} - {{disc.PLETIVO}}
                                    </v-row>
                                    <v-divider class="my-2"></v-divider>
                                </div>
                                <h3 class="my-2">Disciplinas Equivalentes</h3>
                                <v-row class="disciplinas-equivalentes ml-3"
                                    v-for="equiv, ei in selectedAlu.curriculo.filter( d => d.ORDEM == 5)"
                                    :key="'2_'+ei" >
                                    <v-icon small :color="semaforo_color(equiv.SEMAFORO)">mdi-circle</v-icon>
                                    {{equiv.DISCIPLINA}}
                                    <v-spacer></v-spacer>
                                    {{equiv.STATUS}} - {{equiv.PLETIVO}}
                                </v-row>
                                <v-divider class="my-2"></v-divider>
                                <h3 class="my-2">Optativas/Eletivas</h3>
                                <v-row class="optativas-eletivas ml-3"
                                    v-for="oe, ei in selectedAlu.curriculo.filter( d => [3,4].includes(d.ORDEM))"
                                    :key="'3_'+ei">
                                    <v-icon small :color="semaforo_color(oe.SEMAFORO)">mdi-circle</v-icon>
                                    {{oe.DISCIPLINA}}
                                    <v-spacer></v-spacer>
                                    {{oe.STATUS}} - {{oe.PLETIVO}}
                                </v-row>
                                <v-divider class="my-2"></v-divider>
                                <h3 class="my-2">Componente Curricular - ATIVIDADES COMPLEMENTARES</h3>
                                <v-row class="componentes-curriculares ml-3" v-for="ac, ai in selectedAlu.curriculo.filter( d => d.ORDEM == 7)"
                                    :key="'4_'+ai">
                                    <v-icon small :color="semaforo_color(ac.SEMAFORO)">mdi-circle</v-icon>
                                    {{ac.DISCIPLINA}}
                                    <v-spacer></v-spacer>
                                    {{ac.STATUS == 'SIM' ? 'Concluída' : ac.STATUS}} - {{ac.PLETIVO}}
                                    <pre v-show="false">{{ac}}</pre>
                                </v-row>
                                <v-divider class="my-2"></v-divider>
                                <h3 class="my-2">Disciplinas Extras</h3>
                                <v-row class="disciplinas-extras ml-3" v-for="de, di in selectedAlu.curriculo.filter( d => d.ORDEM == 8)"
                                    :key="'5_'+di" >
                                    <v-icon small :color="semaforo_color(de.SEMAFORO)">mdi-circle</v-icon>
                                    {{de.DISCIPLINA}}
                                    <v-spacer></v-spacer>
                                    {{de.STATUS}} - {{de.PLETIVO}}
                                    <pre v-show="false">{{de}}</pre>
                                </v-row>
                                <v-divider class="my-2"></v-divider>
                            </div>
                        </v-card-text>
                    </v-card>
                    <pre v-show="$verify.is_cit()">{{selectedAlu.detalhes}}</pre>
                </div>
            </template>
        </modal-gdb>
        <v-row>
            <v-col cols="12" sm="3" md="3">
                <v-text-field v-model="ra"
                    v-mask="'###-######'"
                    label="RA..."
                    @keyup.enter="getCaderno({ra, codturma, codperlet, codcurso})"
                    clearable></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
                <v-text-field v-model="codperlet"
                    label="Cod. Perlet"
                    :rules="[v=> (v||[]).length > 0 || 'Campo obrigatório']"
                    clearable></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
                <v-text-field  v-model="codturma"
                    label="Cod. Turma"
                    clearable
                    @keyup.enter="getCaderno({ra, codturma, codperlet, codcurso})"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
                <v-btn @click.prevent="getCaderno({ra, codturma, codperlet, codcurso})"
                    :loading="StateCadernoFormandoLoading">
                    <span v-show="$vuetify.display.mdAndUp">Pesquisar</span>
                    <v-icon >mdi-magnify</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-spacer></v-spacer>
            <v-btn
                @click.prevent="export_xls()"
                color="success darken-2" small
                :disabled="StateCadernoFormando.length == 0 || StateCadernoFormandoLoading">
                <v-icon small>mdi-file-excel</v-icon>
                Excel
            </v-btn>
            <v-btn @click.prevent="export_pdf()"
                color="error darken-2" small
                :disabled="StateCadernoFormando.length == 0 || StateCadernoFormandoLoading">
                <v-icon small>mdi-file-pdf-box</v-icon>
                PDF
            </v-btn>
        </v-row>
        <v-row>
            <v-data-table
                multi-sort
                :headers="headers_caderno"
                :items="StateCadernoFormando"
                :items-per-page="10"
                :sort-by="['aluno.NOME']"
                :sort-desc="[false]"
                :loading="StateCadernoFormandoLoading"
                loading-text="carregando..."
                locale="pt-br"
                no-data-text='Nenhum registro'
                no-results-text='Nenhum registro encontrado'
                class="mx-0 datatable_caderno_formando custom-header-style">
                <!-- CODTURMA -->
                <!-- <template #item.turma_detalhe="{ item }">
                    <div class="cell-text">{{item.aluno.CODTURMA}}</div>
                </template> -->
                <!-- RA -->
                <!-- eslint-disable-next-line -->
                <template #item.ra_detalhes="{ item }">
                    <div class="cell-text">{{item.aluno.RA}}</div>
                </template>
                <!-- ALUNO -->
                <!-- eslint-disable-next-line -->
                <template #item.aluno_detalhes="{ item }">
                    <div class="cell-text mb-2">{{item.aluno.NOME}}</div>
                    <div v-if="item.detalhes.length > 0" style="color: #999">
                        <div class="cell-text">
                            <v-row class="pr-4">Turma: <v-spacer></v-spacer> {{item.aluno.CODTURMA}}</v-row>
                        </div>
                        <div class="cell-text">
                            <v-row class="pr-4">Habilitação: <v-spacer></v-spacer> {{item.aluno.IDHABILITACAOFILIAL}}</v-row>
                        </div>
                        <div class="cell-text">
                            <v-row class="pr-4">CR: <v-spacer></v-spacer> {{item.detalhes[0].CR}}</v-row>
                        </div>
                        <div class="cell-text">
                            <v-row class="pr-4">CH Curso: <v-spacer></v-spacer> {{item.detalhes[0].TOTAL_CH_INTEGRALIZADA}} / {{item.detalhes[0].TOTAL_CH}}</v-row>
                        </div>
                        <div class="cell-text">
                            <v-row class="pr-4">Disc. Obrig.: <v-spacer></v-spacer> {{item.detalhes[0].DISC_CONC}} / {{item.detalhes[0].DISC_OBRIG}}</v-row>
                        </div>
                        <div class="cell-text">
                            <v-row class="pr-4">Optativas: <v-spacer></v-spacer> {{item.detalhes[0].OPT_CH_CONC || 0}} / {{item.detalhes[0].OPT_CH_TOTAL || 0}}</v-row>
                        </div>
                        <div class="cell-text">
                            <v-row class="pr-4">Eletivas: <v-spacer></v-spacer> {{item.detalhes[0].ELET_CH_CONC || 0}} / {{item.detalhes[0].ELET_CH_TOTAL || 0}}</v-row>
                        </div>
                        <div class="cell-text">
                            <v-row class="pr-4">ACC/ACT: <v-spacer></v-spacer> {{item.detalhes[0].COMP_CURR_CONC || 0}} / {{item.detalhes[0].COMP_CURR_REQ}}</v-row>
                        </div>
                        <div class="my-2">
                            <v-btn size="small" @click="openAlu(item)">Análise</v-btn>
                        </div>
                    </div>
                </template>
                <!-- EM CURSO -->
                <!-- eslint-disable-next-line -->
                <template #item.em_curso_detalhes="{ item }">
                    <div v-for="curso, index in listaEmCurso(item.curriculo)" :key="index">
                        <div class="cell-text">
                            <helper-gdb :text="curso.CATEGORIA" icon="mdi-information"/>
                            <helper-gdb :text="'<small>'+JSON.stringify(curso)+'</small>'" icon="mdi-xml" v-if="$verify.is_cit() && false"/>
                            {{curso.CATEGORIAID == 9 ? '- ': ''}}
                            {{curso.CODPERIODO ? `${curso.CODPERIODO}º`: ''}}
                            <span :title="curso.CODDISC">{{curso.DISCIPLINA}}</span>
                        </div>
                    </div>
                </template>
                <!-- PENDENTES -->
                <!-- eslint-disable-next-line -->
                <template #item.pendentes_detalhes="{ item }">
                    <div v-for="curso, index in listaPendentes(item.curriculo)" :key="index">
                        <div :class="(StateDark ? 'white--text' : 'text-error')+' cell-text'" >
                            {{curso.CODPERIODO ? `${curso.CODPERIODO}º`: ''}}
                            <span :title="curso.CODDISC">{{curso.DISCIPLINA}}</span>
                        </div>
                    </div>
                </template>
            </v-data-table>
        </v-row>
        <v-row>
            <!-- IMPRESSAO PDF -->
            <div id="imprimir-pdf" v-show="false">
                <div v-for="cf, i in StateCadernoFormando" :key="i" class="item-tabela">
                    <table>
                        <thead>
                            <tr>
                                <th colspan="3" style="text-align:left">
                                    <div style="padding: 3px">
                                        <b style="font-size:18px">{{cf.aluno.RA}} - {{cf.aluno.NOME}}</b>
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                <th style="text-align:left">EM CURSO</th>
                                <th style="text-align:left">PENDENTES</th>
                                <th>ASSINATURA</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="padding: 5px ">
                                <td style="vertical-align: top; width: 40%; font-size: 12px;">
                                    <div v-for="curso, index in listaEmCurso(cf.curriculo)" :key="'cur'+index">
                                        <div>
                                            {{curso.CATEGORIAID == 9 ? '- ': ''}}
                                            {{curso.CODPERIODO ? `${curso.CODPERIODO}º`: ''}}
                                            <span>{{curso.DISCIPLINA}}</span>
                                        </div>
                                    </div>
                                </td>
                                <td style="vertical-align: top; width: 40%; font-size: 12px;">
                                    <div v-for="curso, index in listaPendentes(cf.curriculo)" :key="index">
                                        <div :class="(StateDark ? 'white--text' : 'text-error')+' cell-text'" >
                                            {{curso.CODPERIODO ? `${curso.CODPERIODO}º`: ''}}
                                            <span>{{curso.DISCIPLINA}}</span>
                                        </div>
                                    </div>
                                </td>
                                <td style="vertical-align: top;">
                                    <div>
                                        <div style="font-size: 15px;"> &nbsp;</div>
                                        <div style="text-align:center">_________________________</div>
                                        <div style="text-align:center">Ciente</div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <b>Turma: {{cf.aluno.CODTURMA}}</b>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <div v-if="cf.detalhes.length > 0" style="display: flex;">
                                        <div style="width: 100%;margin: 5px;">
                                            <span style="font-weight: bold">CH Curso</span>
                                            <div style="border-bottom: solid 1px #ddd; margin: 3px 0"></div>
                                            <div>CH total: {{cf.detalhes[0].TOTAL_CH}}</div>
                                            <div>Concluídas: {{cf.detalhes[0].TOTAL_CH_INTEGRALIZADA}}</div>
                                            <div>Pendentes: {{parseInt(cf.detalhes[0].TOTAL_CH.replace('.', ''))-parseInt(cf.detalhes[0].TOTAL_CH_INTEGRALIZADA.replace('.',''))}}</div>
                                        </div>
                                        <div style="width: 100%;margin: 5px;">
                                            <span style="font-weight: bold">Disc. Obrigatórias</span>
                                            <div style="border-bottom: solid 1px #ddd; margin: 3px 0"></div>
                                            <div>Total: {{cf.detalhes[0].DISC_OBRIG}}</div>
                                            <div>Concluídas: {{cf.detalhes[0].DISC_CONC}}</div>
                                            <div>Pendentes: {{cf.detalhes[0].DISC_OBRIG-cf.detalhes[0].DISC_CONC}}</div>
                                        </div>
                                        <div style="width: 100%;margin: 5px;">
                                            <span style="font-weight: bold">Disc. Optativas</span>
                                            <div style="border-bottom: solid 1px #ddd; margin: 3px 0"></div>
                                            <div>CH Total: {{cf.detalhes[0].OPT_CH_TOTAL}}</div>
                                            <div>Concluídas: {{cf.detalhes[0].OPT_CH_CONC}}</div>
                                            <div>Pendentes: {{cf.detalhes[0].OPT_CH_PEND}}</div>
                                        </div>
                                        <div style="width: 100%;margin: 5px;">
                                            <span style="font-weight: bold">Disc. Eletivas</span>
                                            <div style="border-bottom: solid 1px #ddd; margin: 3px 0"></div>
                                            <div>CH Total: {{cf.detalhes[0].ELET_CH_TOTAL}}</div>
                                            <div>Concluídas: {{cf.detalhes[0].ELET_CH_CONC}}</div>
                                            <div>Pendentes: {{cf.detalhes[0].ELET_CH_PEND}}</div>
                                        </div>
                                        <div style="width: 100%;margin: 5px;">
                                            <span style="font-weight: bold">Ativ. Complementar</span>
                                            <div style="border-bottom: solid 1px #ddd; margin: 3px 0"></div>
                                            <div>CH total: {{cf.detalhes[0].COMP_CURR_REQ}}</div>
                                            <div>Concluídas: {{cf.detalhes[0].COMP_CURR_CONC}}</div>
                                            <div>Pendentes: {{cf.detalhes[0].COMP_CURR_PEND}}</div>
                                        </div>
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- IMPRESSAO EXCEL -->
            <div id="imprimir-excel" v-show="false">
                <div>
                    <table>
                        <thead>
                            <tr style="background: #eee">
                                <th>RA</th>
                                <th>ALUNO</th>
                                <th style="text-align:left">EM CURSO</th>
                                <th style="text-align:left">PENDENTES</th>
                                <th>OPTATIVAS</th>
                                <th>ELETIVAS</th>
                                <th>ACC/ACT</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="cf, i in StateCadernoFormando" :key="i">
                                <td style="vertical-align: top;width: 50px">{{ cf.aluno.RA }}</td>
                                <td style="vertical-align: top;width: 150px">
                                    <div>{{cf.aluno.NOME}}</div>
                                    <div v-if="cf.detalhes.length > 0 && false">
                                        <div>CH Curso: {{cf.detalhes[0].TOTAL_CH_INTEGRALIZADA}}/{{cf.detalhes[0].TOTAL_CH}}</div>
                                        <div>Disc. Obrig. {{cf.detalhes[0].DISC_CONC}}/{{cf.detalhes[0].DISC_OBRIG}}</div>
                                        <div>Optativas: {{cf.detalhes[0].OPT_CH_CONC || 0}}/{{cf.detalhes[0].OPT_CH_TOTAL || 0}}</div>
                                        <div>Eletivas: {{cf.detalhes[0].ELET_CH_CONC || 0}}/{{cf.detalhes[0].ELET_CH_TOTAL || 0}}</div>
                                        <div>ACC/ACT: {{cf.detalhes[0].COMP_CURR_CONC || 0}}/{{cf.detalhes[0].COMP_CURR_REQ}}</div>
                                    </div>
                                </td>
                                <td style="vertical-align: top;">
                                    <div v-for="curso, index in listaEmCurso(cf.curriculo)"
                                        :key="'cur'+index">
                                        <div>
                                            {{curso.CATEGORIAID == 9 ? '- ': ''}}
                                            {{curso.CODPERIODO ? `${curso.CODPERIODO}º`: ''}}
                                            <span>{{curso.DISCIPLINA}}</span>
                                        </div>
                                    </div>
                                </td>
                                <td style="vertical-align: top;">
                                    <div v-for="curso, index in listaPendentes(cf.curriculo)" :key="index">
                                        <div :class="(StateDark ? 'white--text' : 'text-error')+' cell-text'" >
                                            {{curso.CODPERIODO ? `${curso.CODPERIODO}º`: ''}}
                                            <span>{{curso.DISCIPLINA}}</span>
                                        </div>
                                    </div>
                                </td>
                                <td style="vertical-align: top; width: 100px; text-align: center;">
                                    <div v-if="cf.detalhes.length > 0">{{cf.detalhes[0].OPT_CH_CONC || 0}} / {{cf.detalhes[0].OPT_CH_TOTAL || 0}}</div>
                                </td>
                                <td style="vertical-align: top; width: 100px; text-align: center;">
                                    <div v-if="cf.detalhes.length > 0">{{cf.detalhes[0].ELET_CH_CONC || 0}} / {{cf.detalhes[0].ELET_CH_TOTAL || 0}}</div>
                                </td>
                                <td style="vertical-align: top; width: 100px; text-align: center;">
                                    <div v-if="cf.detalhes.length > 0">{{cf.detalhes[0].COMP_CURR_CONC || 0}}/{{cf.detalhes[0].COMP_CURR_REQ}}</div>
                                    <!-- <div v-for="curso, index in atividadesComplementares(cf.curriculo)"
                                        :key="'acc_'+index">
                                        <div>
                                            <span>{{curso.DISCIPLINA}}</span>
                                        </div>
                                    </div> -->
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </v-row>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    components:{
    },
    data:()=>({
        selectedAlu: {},
        ra:'',
        codturma:'',
        codcurso:'',
        codperlet:'',
        headers_caderno: [
            // { title: 'TURMA', align: 'start', sortable: true, value: 'turma_detalhe', width:'75'},
            { title: 'RA', align: 'start', sortable: true, value: 'ra_detalhes', width:'85'},
            { title: 'ALUNO', align: 'start', sortable: true, value: 'aluno_detalhes', width:'150'},
            { title: 'DISCIPLINAS EM CURSO', align: 'start', sortable: false, value: 'em_curso_detalhes', },
            { title: 'DISCIPLINAS PENDENTES', align: 'start', sortable: false, value: 'pendentes_detalhes', },
        ],
    }),
    methods:{
        ...mapActions(['GetCadernoFormando']),
        async getCaderno(options){
            if(!options.ra && !options.codturma){
                alert('Turma ou RA não informado')
                return
            }
            if(!options.codperlet){
                alert('Período Letivo não informado')
                return
            }
            return await this.GetCadernoFormando(options)
        },
        export_xls(){
            // var data_type = 'data:application/vnd.ms-excel';
            var table_div = document.getElementById('imprimir-excel')
            table_div = table_div.children[0].children[0]
            var blobData = new Blob(['\ufeff'+table_div.outerHTML], { type: 'application/vnd.ms-excel' });
            var url = window.URL.createObjectURL(blobData);
            var a = document.createElement('a');
            a.href = url;
            a.download = 'export_caderno.xls';
            a.click();
        },
        async export_pdf(){
            var page = ''
            var body = ''
            var title_div = document.createElement('h3')
            title_div.innerHTML = 'Formandos UNDB - '+ this.codperlet
            title_div.style.width = '840px'
            title_div.style.marginTop = '20px'
            title_div.style.paddingBottom = '20px'
            title_div.style.textAlign = 'center'
            body = document.getElementById('imprimir-pdf')
            body = body.innerHTML
            let emitido_em = new Date().toLocaleDateString()
            page += `
                <html>
                <head>
                    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
                    <link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@300&family=Poppins:wght@300&display=swap" rel="stylesheet">
                    <style>
                        table{
                            width: 100%;
                            margin-bottom: 30px;
                            page-break-inside: avoid;
                        }
                        .pagebreak {
                            page-break-after: always;
                        }
                        *{
                            font-family: 'Poppins', sans-serif;
                            font-size: 11px;
                        }
                        h3{
                            font-family: 'Poppins', sans-serif;
                            font-size: 16px;
                        }
                        .item-tabela {
                            border-bottom-style: solid;
                            border-bottom-width: 1px;
                            border-color: #aaa;
                            margin-bottom: 10px;
                        }
                    </style>
                </head>
                <body>
                    <div style="display: inline-flex;margin-bottom:50px;width:100%">
                        <img src="/assets/img/logoUNDB.png" width="160px" style="object-fit: contain;" />
                        <div style="width:100%; text-align:center">
                            <h3> Caderno de Formandos - ${this.codperlet}</h3>
                        </div>
                        <div style="width:200px; text-align:right">
                            <div>
                                <small> Emitido em: ${emitido_em}</small>
                            </div>
                            <div>
                                <small> por: ${this.StateAuthenticatedUser.username}</small>
                            </div>
                        </div>
                    </div>
                    ${body}
                </body>
                </html>
            `;

            var newWindow = window.open();
            newWindow.document.write(page);
            newWindow.document.close();
            newWindow.onload = function(){
                newWindow.focus()
                newWindow.print()
                newWindow.close()
            }
        },
        openAlu(alu){
            this.selectedAlu = Object.assign({}, alu)
            this.$refs.modal_caderno_formando.dialog = true
        },
        closeModal(){
            this.$refs.modal_caderno_formando.dialog = false
            this.selectedAlu = Object.assign({}, {})
        },
        semaforo_color(id){
            switch(id){
                case 1: return 'success'
                case 2: return 'error'
                case 3: return 'yellow'
                default: return 'grey'
            }
        },
        listaPendentes(lista){
            return lista.filter(c => 1 == 1
                    /* Pendentes */
                    && c.CATEGORIAID == 2
                    /* PEND */
                    && c.SEMAFORO == 2
                    /* Ignora TEORIA */
                    && c.DISCIPLINA.indexOf('- TEORIA') == -1
                    /* Ignora PRATICA */
                    && c.DISCIPLINA.indexOf('- PRATICA') == -1
                )
        },
        listaEmCurso(lista){
            return lista.filter(c =>
                    /* Pendentes*/
                    /* Não Concluídas */
                    (c.CATEGORIAID === 2 && c.SEMAFORO === 3)
                    /* Optativas e eletivas em curso */
                    || ([4,5].includes(c.CATEGORIAID) && c.STATUS == 'EM CURSO')
                    /* Extras Não Concluídas */
                    || (c.CATEGORIAID === 9 && c.STATUS == 'EM CURSO')
                )
        },
        optativasEletivas(lista){
            return lista.filter(c =>
                    /* Optativas e eletivas em curso */
                    ([4,5].includes(c.CATEGORIAID) && c.STATUS == 'EM CURSO')
                )
        },
        atividadesComplementares(lista){
            return lista.filter(c =>
                    /* Optativas e eletivas em curso */
                    ([8].includes(c.CATEGORIAID))
                )
        }
    },
    computed: {
        ...mapGetters([
            'StateCadernoFormando',
            'StateCadernoFormandoLoading',
            'StateDark',
            'StateAuthenticatedUser']),
    },
    mounted(){
        let y = new Date().getFullYear()
        let m = new Date().getMonth()+1
        this.codperlet = `${y}${(m > 6 ? '.2' : '.1')}`
    }
}
</script>
<style scoped>
.cell-text{
    font-size: 11px;
}
</style>
<style>
tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, .03);
}
.datatable_caderno_formando tbody{
    vertical-align: text-top !important;
}
.datatable_caderno_formando tbody tr td,.datatable_caderno_formando thead tr th{
    padding: 5px !important;
}
.analise-curricular{
    font-size: 11px;
}
.analise-curricular .componentes-curriculares{
    font-size: 10px;
}
</style>